import {Dropdown} from "react-bootstrap";
import {SORT_VARIANTS, SortType} from "../../utils/productSort";

export default function ProductListSort({sortType, setSortType}: { sortType: SortType, setSortType: (sortType: SortType) => void }) {
    return (<div className="d-flex align-items-center gap-2">
        <img src="/images/icon-sort.svg" alt=""/>
        <span className="text-secondary">Сортировка по:</span>
        <Dropdown className="catalog__sort">
            <Dropdown.Toggle as="button" type="button"
                             className="dropdown-toggle catalog__btn-sort">{SORT_VARIANTS[sortType]}</Dropdown.Toggle>
            <Dropdown.Menu>
                {(Object.keys(SORT_VARIANTS) as SortType[]).map(value =>
                    <Dropdown.Item key={value} as="button" type="button"
                                   active={value === sortType}
                                   onClick={() => setSortType(value)}>{SORT_VARIANTS[value]}</Dropdown.Item>)}
            </Dropdown.Menu>
        </Dropdown>
    </div>)
}
